export default "__VITE_ASSET__Di129Xx___"